import React, {
  useState,
  useEffect,
  useRef,
  forwardRef,
  RefObject,
} from "react";
// import { useInView } from "react-intersection-observer";
import ReactGA from "react-ga4";

import Banner from "../banner/banner";
import Page from "../page/page";
import { ReactComponent as ZoomInIcon } from "../../assets/icons/zoomIn.svg";
import { useLocation, useNavigate } from "react-router-dom";

import "./welcomePage.scss";
import classnames from "classnames";
import { useMediaQuery } from "@react-hook/media-query";
import classNames from "classnames";

const ActionButtons = ({ nav }) => {
  const navigate = useNavigate();

  return (
    <></>
    // <div className="actionButtonsContainer">
    //   <button
    //     className="actionButton eventsButton"
    //     onClick={() => navigate("/events")}
    //   >
    //     Nos évènements
    //   </button>
    // </div>
  );
};

const WelcomePage = () => {
  const isPortrait = useMediaQuery("only screen and (orientation: portrait)");
  const containerRef = useRef<HTMLDivElement>(null);
  const [nextEventArraytext, setNextEventArraytext] = useState([
    "Ouverture de l'arène : ",
    "chargement en cours ...",
  ]);
  const [nextEventUrl, setNextEventUrl] = useState("");
  const [lastTwitchStreamUrl, setLastTwitchStreamUrl] = useState(
    "https://www.twitch.tv/shotamsekai",
  );

  const [focusedZone, setFocusedZone] = useState(null);
  const navigate = useNavigate();
  const targetRef = useRef(null);

  const nav = () => {
    //@ts-ignore
    targetRef?.current?.scrollIntoView({ behavior: "smooth" });
  };
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname,
      title: "Welcome Page",
    });
    // fetch(
    //   `https://firestore.googleapis.com/v1/projects/shotam-b276d/databases/(default)/documents/general_information/main`,
    // )
    //   .then((res) => {
    //     res.json().then((obj) => {
    //       let label = obj.fields.next_event.stringValue;
    //       let url = obj.fields.next_event_url.stringValue;
    //       setNextEventArraytext(["Ouverture de l'arène : ", label]);
    //       setNextEventUrl(url);
    //     });
    //   })
    //   .catch(() => {});
  }, []);

  const getArrayTexts = () => {
    return nextEventArraytext;
  };

  return (
    <Page style={{ paddingBottom: "0px" }}>
      {/* <div className="backPage"></div> */}
      {/*@ts-ignore*/}
      <div className={classnames("welcomeBigtext")}>
        {isPortrait ? (
          <>
            <span className="welcomeBigText2">Le ring</span>
            <span className="welcomeBigText1">virtuel </span>
            <div className="welcomeBigText3">100% MANGA</div>
            <div className="welcomeHint1">En partenariat avec la BPI</div>
            <div className="welcomeHint2">
              {" "}
              & l'INRIA, Institut National de Recherche
            </div>
          </>
        ) : (
          <>
            <span className="welcomeBigText2">Le ring</span>{" "}
            <span className="welcomeBigText1">virtuel</span>
            <div className="welcomeBigText3">100% MANGA</div>
            <div className="welcomeHint1">En partenariat avec la BPI</div>
            <div className="welcomeHint2">
              & l'INRIA, Institut National de Recherche
            </div>
          </>
        )}
      </div>
      {!isPortrait ? (
        <ActionButtons {...{ nav }} />
      ) : (
        <></>
        // <div className="hintDown"></div>
      )}
      <div className="firstPagePlaceholder" />
      <div className="sectionTwo">
        <div className="presenter">
          <div className="presenterSection">
            <div className="welcomeBigText4 presenterText">Entre</div>
            <div className="welcomeBigText5 presenterText">dans le ring _</div>
            <img className="explainImage" src="./game/insideRing.png" />
          </div>

          <div className="presenterSection">
            <div className="welcomeBigText4 presenterText">Choisis</div>
            <div className="welcomeBigText5 presenterText">tes pouvoirs _</div>
            <img className="explainImage" src="./game/characterChoice.png" />
          </div>

          <div className="presenterSection">
            <div className="welcomeBigText4 presenterText">Et ...</div>
            <div className="welcomeBigText5 presenterText"> FIGHT !</div>
            <img className="explainImage" src="./game/inFightImage.png" />
          </div>
          {isPortrait ? <ActionButtons {...{ nav }} /> : <></>}
        </div>
      </div>
      {/* {isPortrait ? (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <button
            className="bookingButton"
            // disabled={true}
            onClick={() => navigate("/booking")}
          >
            Réserver une session
          </button>
        </div>
      ) : (
        <></>
      )} */}
      <div className="sectionOne">
        <div className="videoAndBannersContainer">
          <div className="videoTitle">
            Notre concept est né en 2022 avec un seul et unique but : pouvoir se
            battre comme dans un manga !
            <br />
            <br />
            Dans le ring Shotam, l'impossible devient possible : frapper sans
            limite, souffler des boules de feu, invoquer des grenouilles, se
            téléporter sous terre .. et bien plus !
            <br />
            <br />
            Plus de 1000 familles ont découvert Shotam partout en France !
            {/* Un combat multijoueur adaptable à tous les espaces de jeu !
            <br />
            <br />
            - Petit Format : Arcade ------------------ [3m x 3m // 1 VS 1]
            <br />
            - Moyen Format : Evènementiel --------- [6m x 11m // 2 VS 2]
            <br />- Grand Format : Sport ------------------ [Pelouse // 3 VS 3] */}
            {/* Notre technologie repose entièrement sur la reconnaissance de tes
            mouvements : tu vas devoir frapper, esquiver, faire des invocations,
            lancer des boules d'énergie ... pour de vrai !{" "} */}
            <div className="arrowDown"></div>
            <div className="arrowDown2"></div>{" "}
          </div>
          <div className="videoWrapper">
            {isPortrait ? (
              <iframe
                width="100%"
                height="600"
                src="https://www.youtube.com/embed/fPEWi6GnPts"
                title="Shotam : Trailer"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen"
              ></iframe>
            ) : (
              <div className="trailerContainer">
                <iframe
                  width="500"
                  height="282"
                  // src="https://www.youtube.com/embed/RTw6ekGqoyQ"
                  src="https://www.youtube.com/embed/fPEWi6GnPts"
                  title="Shotam : Trailer"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen"
                ></iframe>
              </div>
            )}
          </div>
          {isPortrait ? <ActionButtons {...{ nav }} /> : <></>}
        </div>
      </div>

      <div className={classnames("sectionTwo", "sectionThree")} ref={targetRef}>
        <div style={{ width: "100% ", textAlign: "center", marginTop: 50 }}>
          Ils nous ont fait confiance !
        </div>
        <img className="explainImage" src="./recos.png" />
        <div style={{ width: "90%", height: "1px", background: "#000" }}></div>
        <div
          style={{
            width: "100% ",
            textAlign: "center",
            marginTop: 100,
            marginBottom: 0,
          }}
        >
          Prêts pour un moment inoubliable ?!
        </div>
        {/* <div className="switchContainer" style={{ marginTop: 20 }}>
          <button className={classNames("switch")}>2 joueurs</button>
          <div className="or">à</div>
          <button className={classNames("switch")}>12 joueurs</button>
        </div>
        <div className="switchContainer">
          <button className={classNames("switch")}>Chez vous</button>
          <div className="or">ou</div>
          <button className={classNames("switch")}>Chez nos partenaires</button>
        </div>
        <div className="switchContainer">
          <button className={classNames("switch")}>Pour un anniversaire</button>
          <div className="or">ou</div>
          <button className={classNames("switch")}>Toute autre fête !</button>
        </div> */}
        <div style={{ width: "100% ", textAlign: "center", marginTop: 50 }}>
          Contactez-nous pour réserver notre activité !<br></br>
        </div>
        <a
          className={classNames("mailLink", "showBookingButton")}
          href="mailto:contact@shotam.com"
        >
          contact@shotam.app
        </a>

        <a
          href="tel:+33628539209"
          className={classNames("mailLink", "showBookingButton")}
        >
          +33 628 53 92 09
        </a>

        {/* <div style={{ width: "100% ", textAlign: "center", marginTop: 50 }}>
          En famille, entre amis, ou entre collègues, l'expérience Shotam est
          unique !
        </div>
        <div className="presenter">
          <div className="presenterSection">
            <div className="welcomeBigText4 presenterText"> Collaborez </div>
            <div className="welcomeBigText5 presenterText"> en équipe </div>
            <div className="imageAndTextContainer">
              <img
                className="explainImage"
                src="./teambuildings/teamplay.png"
              />
              <div className="imageExplanation">
                Élaborez ensemble votre stratégie d'attaque/défense en fonction
                de vos pouvoirs respectifs !
              </div>
            </div>
          </div>

          <div className="presenterSection">
            <div className="welcomeBigText4 presenterText">Brûlez</div>
            <div className="welcomeBigText5 presenterText"> des calories</div>
            <div className="imageAndTextContainer">
              <img className="explainImage" src="./teambuildings/motion.png" />
              <span className="imageExplanation">
                Das l'arène Shotam, tous vos mouvements deviennent un
                superpouvoir !
              </span>
            </div>
          </div>

          <div className="presenterSection">
            <div className="welcomeBigText4 presenterText">Amusez-vous </div>
            <div className="welcomeBigText5 presenterText"> comme jamais !</div>
            <div className="imageAndTextContainer">
              <img className="explainImage" src="./teambuildings/fun.png" />
              <span className="imageExplanation">
                Qui n'a jamais rêvé de devenir un superhéros ?
              </span>
            </div>
          </div>
        </div> */}
      </div>
      <div className="bottomBanner">
        <button onClick={() => navigate("/contact")}>Contact</button>
        <button onClick={() => navigate("/privacy")}>
          Politique de confidentialité
        </button>
        <button onClick={() => navigate("/partners")}>
          Conventions passées
        </button>
      </div>
    </Page>
  );
};

export default WelcomePage;
